import React, { useEffect, useRef } from 'react';
import '@mux/mux-video';
import { useFrodorModules } from '../../../../Context/FrodorModulesProvider';
export const S4XMuxVideo = ({ muxPlaybackId, playing, muted = true, loop = false, autoPlay = false, overridePreload, ...props }) => {
    const ref = useRef();
    const { preloadVideo } = useFrodorModules();
    useEffect(() => {
        var _a, _b, _c, _d;
        if (ref.current) {
            ref.current.muted = muted;
            ref.current.loop = loop;
            ref.current.autoplay = autoPlay;
        }
        if (playing && ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.paused)) {
            (_b = ref.current) === null || _b === void 0 ? void 0 : _b.play();
        }
        if (!playing && !((_c = ref.current) === null || _c === void 0 ? void 0 : _c.paused)) {
            (_d = ref.current) === null || _d === void 0 ? void 0 : _d.pause();
        }
    }, [playing, ref, muted, loop, autoPlay]);
    const src = `https://stream.mux.com/${muxPlaybackId}.m3u8?t=0.001&max_resolution=720p`;
    return (React.createElement("mux-video", { ref: ref, src: src, "max-resolution": "720p", poster: props.poster ||
            `https://image.mux.com/${muxPlaybackId}/thumbnail.jpg?time=.001`, playsInline: true, preload: overridePreload || preloadVideo, tabIndex: -1, ...props }));
};
